import React from "react"

import { useSelector } from "react-redux"
import QRcode from "./QRcode"
import QRcodeWelcomeMessageES from "./QRcodeWelcomeMessageES"

const PatientES = () => {

    const listItems = useSelector(store => store.reply.patientData)

    return (
        <>  
            <h1 className="title">Resumen: Datos del cuestionario</h1>
            <QRcodeWelcomeMessageES />
            <QRcode />
            
            {listItems.map((item) => (
            <div className="patients" key={item._id}>

                <div> <span className="time-info">registrado: </span>{String(item.createdAt).split('T')[0]}</div>
                <h2 className="subtitle">Sección 1. Preguntas generales</h2>

                <div className="time"> {item.createdAt}</div>



                <div><span className="basic-info">username: </span> 
                    {item.username}
                </div>

                <div><span className="basic-info">edad: </span>
                    {item.age}
                </div>

                <div><span className="basic-info">genero: </span> 
                    {item.gender}
                </div>

                <div><span className="basic-info">Tipo de diabetes: </span> 
                    {item.diabetesType}
                </div>

                <div><span className="basic-info">¿En que región vives? </span> 
                    {item.q1}
                </div>

                <div>
                    <span className="basic-info">
                        ¿Cuando fuiste diagnosticado con diabetes? 
                    </span> 
                    {item.diagnosisYear}
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Como manejas actualmente tu condición? ej., insulina, medicamentos, suplementos 
                        dietéticos, dieta, ejercicio. Por favor, explica.
                    </span>
                    <div className="answers">
                        {item.q2}
                    </div> 
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Con que frecuencia chequeas tus niveles de azúcar en la sangre?
                    </span>
                    <div className="answers">
                        {item.q3}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Cual es para ti el aspecto mas difícil de tener diabetes?
                    </span>
                    <div className="answers">
                        {item.q4}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Alguna vez has recibido ayuda profesional para guiarte en tu dieta? Por favor, 
                        cuéntanos sobre tu experiencia con seguir una dieta para la diabetes.
                    </span>
                    <div className="answers">
                        {item.q5}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Cual crees que es el aspecto mas difícil de seguir una dieta para controlar 
                        la diabetes?
                    </span>
                    <div className="answers">
                        {item.q6}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Has tenido algún problema relacionado con la diabetes en el lugar de trabajo?
                    </span>
                    <div className="answers">
                        {item.q7}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿El lugar donde trabajas/trabajabas te brindo algún tipo de apoyo relacionado 
                        con diabetes? Si es así, por favor describe como.
                    </span>
                    <div className="answers">
                        {item.q8}
                    </div>
                </div>
                
                <div>
                    <span className="basic-questions">
                        ¿Que tan cómodo te sientes con el uso de la tecnología y las aplicaciones 
                        móviles? ¿Alguna vez has usado una aplicación digital para ayudarte con la 
                        gestión de la diabetes? Si es así, por favor cuéntanos cual y tu experiencia.
                    </span>
                    <div className="answers">
                        {item.q9}
                    </div>
                </div>

                <h2 className="subtitle">Sección 2. Sobre GlucoNutris</h2>
                
                <div>
                    <span className="basic-questions">
                        ¿Que tipo de cosas querrías en una aplicación para pacientes con diabetes?
                    </span>
                    <div className="answers">
                        {item.qA1}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Cual es el aspecto mas importante de la gestión diabética de la diabetes con 
                        el que te gustaría que una aplicación te ayude?
                    </span>
                    <div className="answers">
                        {item.qA2}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Te gustaría que una aplicación incluyera métodos interactivos, como cuestionarios 
                        o trivias, para educarte sobre diabetes?
                    </span>
                    <div className="answers">
                        {item.qA3}
                    </div>
                </div>

                <h4 className="sub-subtitle">
                    Por favor, califica la utilidad de las siguientes características en una aplicación 
                    móvil que te ayuda a la gestión de tu dieta (1- inútil, 5- excelente): 
                </h4>

                <div>
                    <span className="basic-questions">
                        Adquirir conocimientos sobre diabetes a través de métodos interactivos. Por favor, 
                        califique en la escala de inútil (1) a excelente (5)
                    </span>
                    <div className="answers">
                        {item.qA4r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Tener una evaluación nutricional y mis requerimientos nutricionales calculados. 
                        Por favor, califique en la escala de inútil (1) a excelente (5)
                    </span>
                    <div className="answers">
                        {item.qA5r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Obtener mi plan de comidas personalizado. 
                        Por favor, califique en la escala de inútil (1) a excelente (5)
                    </span>
                    <div className="answers">
                        {item.qA6r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Registrar mis comidas. Por favor, califique en la escala de inútil (1) a excelente (5)
                    </span>
                    <div className="answers">
                        {item.qA7r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Realizar un seguimiento de mi actividad física. Por favor, califique en la escala 
                        de inútil (1) a excelente (5)
                    </span>
                    <div className="answers">
                        {item.qA8r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Tener consultas en línea con nutricionistas/dietistas. 
                        Por favor, califique en la escala de inútil (1) a excelente (5) 
                    </span>
                    <div className="answers">
                        {item.qA9r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Recibir una lista de compras personalizada para un plan semanal de mis 
                        comidas. Por favor, califique en la escala de inútil (1) a excelente (5) 
                    </span>
                    <div className="answers">
                        {item.qA10r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Obtener sugerencias de menú semanal con recetas. 
                        Por favor, califique en la escala de inútil (1) a excelente (5)
                    </span>
                    <div className="answers">
                        {item.qA11r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Acceder a un pool de recetas aptas para diabéticos. 
                        Por favor, califique en la escala de inútil (1) a excelente (5) 
                    </span>
                    <div className="answers">
                        {item.qA12r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Realizar un seguimiento de mis mediciones de azúcar en sangre. 
                        Por favor, califique en la escala de inútil (1) a excelente (5) 
                    </span>
                    <div className="answers">
                        {item.qA13r}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        Realizar un seguimiento de mi pulso y presión arterial. 
                        Por favor, califique en la escala de inútil (1) a excelente (5) 
                    </span>
                    <div className="answers">
                        {item.qA14r}
                    </div>
                </div>

                <h4 className="sub-subtitle">
                    También nos gustaría pedirle su opinión sobre lo siguiente: 
                </h4>

                <div>
                    <span className="basic-questions">
                        ¿Te gustaría una aplicación que proporcione opciones para diferentes 
                        dietas (por ejemplo, dieta mediterránea, dieta cetogénica, dieta sin gluten, 
                        dieta vegetariana) o una que ajuste un plan de alimentación en función de tus 
                        preferencias personales?
                    </span>
                    <div className="answers">
                        {item.qA15}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Te gustaría tener la opción de encontrar y seleccionar fácilmente comidas 
                        de preparación rápida o con pocos ingredientes en la aplicación?
                    </span>
                    <div className="answers">
                        {item.qA16}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Te gustaría tener la opción de unirte a una comunidad dentro de la aplicación 
                        donde puedas hablar con otras personas que tienen diabetes y obtener ayuda de 
                        expertos en salud? 
                    </span>
                    <div className="answers">
                        {item.qA17}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Crees que seria útil tener un programa de recompensas por adherir a tu plan 
                        de alimentación? Como recibir regalos, descuentos en equipos de entrenamiento 
                        o consultas extras con dietistas o quizás tengas alguna sugerencia?
                    </span>
                    <div className="answers">
                        {item.qA18}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Te parecería conveniente tener la opción de reservar citas regularmente con un 
                        dietista/nutricionista a través de la aplicación?
                    </span>
                    <div className="answers">
                        {item.qA19}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Que tipo de apoyo o función de una aplicación de salud digital para el 
                        manejo de la dieta en diabetes harían mas probable que adhieras a los 
                        cambios en tu estilo de vida?
                    </span>
                    <div className="answers">
                        {item.qA20}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Podrías decirme si te gustaría una función que permita a los usuarios crear 
                        y compartir sus propias recetas de platos? ¿Con el beneficio adicional de que 
                        las recetas sean revisadas por un dietista/nutricionista antes de que se 
                        publiquen? Y también, ¿como crees que esta característica ayudaría a mantener 
                        la adherencia de los usuarios a la aplicación?
                    </span>
                    <div className="answers">
                        {item.qA21}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Por que características especificas de la aplicación estarías dispuesto a pagar?
                    </span>
                    <div className="answers">
                        {item.qA22}
                    </div>
                </div>

                <div>
                    <span className="basic-questions">
                        ¿Hay algo mas que te gustaría compartir?
                    </span>
                    <div className="answers">
                        {item.qA23}
                    </div>
                </div>

            </div>
            ))}
            <h2 className="patient-placeholder">PLACEHOLDER</h2>
        </>
    )
}

export default PatientES